exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sortable-ghost[data-v-602fadee] {\n    background-color: #eeeeee;\n}\n.sortable-fallback[data-v-602fadee] {\n    display: none;\n}\n", ""]);

// exports
